import { mangas } from "@/mocks/mangas";
import { articles } from "@/mocks/articles";
import { categories } from "@/mocks/categories";

export function getCategoryBySlug(slug: string) {
  return categories.find((c) => c.slug === slug);
}

export function getMangaBySlug(slug: string) {
  return mangas.find((m) => m.slug === slug);
}

export function getArticleBySlug(slug: string) {
  return articles.find((a) => a.slug === slug);
}

export function getMangasByCategory(slug: string) {
  return mangas.filter((m) => m.category === slug);
}